import Icon from '@ant-design/icons';

import {
  updateStoreOverview,
  updateStoreInfo,
  updateStoreSettings,
  publishStore
} from 'services/online-store';
import { ALWAYS, LESS_THAN } from 'constants/products';
import { CUSTOM_DOMAINS_STATUSES } from 'constants/sllr';
import { smartUrlRedirection } from 'utils/redirections';
import { isDashboardArabic } from 'utils/intl-wrapper';
import { LOCALE } from 'constants/intl-wrapper';
import { URLS } from 'constants/urls';

import { fmt } from 'components/IntlWrapper/IntlWrapper';
import { notify } from 'components/Notify/Notify';
import ActivationModal from 'components/BRModals/ActivationModal/ActivationModal';

import { ReactComponent as UncreatedSllrBannerIcon } from 'assets/bosta-icons/sllr-draft-order.svg';

export const openPublishFirstModal = ({
  openModal,
  onOk = () => {},
  subtitle
}) => {
  openModal(ActivationModal, {
    icon: (
      <Icon
        className="br-uncreated-sllr-banner__modal-icon"
        component={UncreatedSllrBannerIcon}
      />
    ),
    title: fmt({
      id: 'products.sllr_store.preview_modal.title'
    }),
    subtitle:
      subtitle ||
      fmt({
        id: 'products.sllr_store.preview_modal.subtitle'
      }),
    buttonText: fmt({
      id: 'products.sllr_store.preview_modal.confirm_btn'
    }),
    cancelText: fmt({
      id: 'products.uncreated_sllr.modal.cancel'
    }),
    onOk
  });
};

export const handlePublishStore = async ({
  userSllrLink,
  openStoreAfterPublish = false,
  afterPublish = () => {}
}) => {
  try {
    const payload = {
      storeInfo: { isPublished: true }
    };
    await publishStore(payload);
    notify({
      msg: fmt({
        id: 'products.sllr_store.published'
      }),
      type: 'success',
      ...(!openStoreAfterPublish && {
        extraAction: {
          action: () => window.open(userSllrLink),
          label: fmt({
            id: 'products.sllr_store.preview_store'
          })
        }
      })
    });
    if (openStoreAfterPublish) {
      window.open(userSllrLink, '_blank');
    }
    afterPublish();
  } catch (error) {
    notify({ msg: error.message, error });
  }
};

export const getAllowBuyingOptions = () => {
  return [
    {
      value: true,
      label: fmt({
        id: 'products.sllr_store.setting_page.general_tab.stock.allow_buying'
      })
    },
    {
      value: false,
      label: fmt({
        id: 'products.sllr_store.setting_page.general_tab.stock.dont_allow_buying'
      })
    }
  ];
};

export const getRemainingQuantityOptions = (quantity) => {
  return [
    {
      value: ALWAYS,
      label: fmt({
        id: 'products.sllr_store.setting_page.general_tab.stock.always'
      })
    },
    {
      value: LESS_THAN,
      label: fmt(
        {
          id: 'products.sllr_store.setting_page.general_tab.stock.less_than'
        },
        {
          number: quantity
        }
      )
    }
  ];
};

export const getSllrLink = (businessInfo, formValues) => {
  let storeLink;
  if (
    businessInfo?.storeInfo?.domainStatus === CUSTOM_DOMAINS_STATUSES.CONNECTED
  ) {
    storeLink = `https://${businessInfo?.storeInfo?.customDomain}/`;
  } else if (formValues) {
    storeLink = smartUrlRedirection({
      base: URLS.SLLR_STORES,
      extraURLData: formValues
    });
  } else {
    storeLink = businessInfo?.storeInfo?.storeLink
      ? smartUrlRedirection({
          base: URLS.SLLR_STORES,
          extraURLData: businessInfo?.storeInfo?.storeLink
        })
      : false;
  }
  return storeLink;
};

export const getStoreName = ({ storeName, storeNameAr, lang }) => {
  const nameEn = storeName || storeNameAr;
  const nameAr = storeNameAr || storeName;

  switch (lang) {
    case LOCALE.EN:
      return nameEn;

    case LOCALE.AR:
    case LOCALE.AR_SA:
      return nameAr;

    default:
      return isDashboardArabic() ? nameAr : nameEn;
  }
};

export const updateStoreFeatureConfiguration = async ({
  payload = {},
  isSettings
}) => {
  if (window.location.pathname.includes('/sllr/store')) {
    await updateStoreInfo(payload);
  } else if (
    window.location.pathname.includes('/sllr/settings') ||
    isSettings
  ) {
    await updateStoreSettings(payload);
  } else {
    await updateStoreOverview(payload);
  }
};
